/*
 * Ateliers / visites : masque les dates passées du sélecteur de variantes.
 * Complète le filtrage Liquid (snippets/product-variant-options.liquid), qui peut être servi
 * depuis le cache de page, et resélectionne la prochaine date si la variante active est passée.
 */
(() => {
  const NO_UPCOMING_DATES_LABEL = 'Aucune date à venir pour le moment';

  const today = () => {
    const now = new Date();
    return now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate();
  };

  const isSelected = (element) => (element.tagName === 'OPTION' ? element.hasAttribute('selected') : element.checked);

  const showNoUpcomingDates = (variantSelects) => {
    const sectionId = variantSelects.dataset.section;
    const submitButton = document.querySelector(`#product-form-${sectionId} [name="add"]`);
    if (submitButton) {
      submitButton.setAttribute('disabled', 'disabled');
      const label = submitButton.querySelector('.product-form__submit-label');
      if (label) label.textContent = window.variantStrings.unavailable;
    }
    document.getElementById(`Inventory-${sectionId}`)?.classList.add('hidden');
    // Masque aussi le bandeau de stock de l'app (.nm-portal), injecté parfois après ce script
    document.body.classList.add('event-dates--none-upcoming');

    variantSelects.querySelectorAll('select').forEach((select) => {
      if (select.options.length) return;
      select.append(new Option(NO_UPCOMING_DATES_LABEL, '', true, true));
      select.disabled = true;
    });
    variantSelects.querySelectorAll('fieldset').forEach((fieldset) => {
      if (fieldset.querySelector('input') || fieldset.querySelector('.event-dates__empty')) return;
      const message = document.createElement('p');
      message.className = 'event-dates__empty';
      message.textContent = NO_UPCOMING_DATES_LABEL;
      fieldset.append(message);
    });
  };

  const pruneVariantSelects = (variantSelects) => {
    if (!variantSelects.hasAttribute('data-event-dates')) return;

    const todayNumber = today();
    variantSelects.querySelectorAll('[data-event-date]').forEach((element) => {
      if (Number(element.dataset.eventDate) >= todayNumber) return;
      if (element.tagName === 'INPUT') variantSelects.querySelector(`label[for="${element.id}"]`)?.remove();
      element.remove();
    });

    const upcoming = Array.from(variantSelects.querySelectorAll('[data-event-date]'));

    if (!variantSelects.querySelector('select option, fieldset input')) {
      showNoUpcomingDates(variantSelects);
      return;
    }

    if (!upcoming.length || upcoming.some(isSelected)) return;

    // La variante active (sélection par défaut ou ?variant=) est passée : on bascule sur la prochaine date
    const next = upcoming[0];
    if (next.tagName === 'OPTION') {
      next.setAttribute('selected', 'selected');
      next.selected = true;
      next.closest('select').dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      next.checked = true;
      next.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const pruneAll = () => document.querySelectorAll('variant-selects').forEach(pruneVariantSelects);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pruneAll);
  } else {
    pruneAll();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => requestAnimationFrame(pruneAll));
  }
})();
